export { waitForAddedCompRef } from './waitForAddedCompRef';
